import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ykttxenut: FaireBrandEntity = {
  token: "b_7ykttxenut",
  type: "brand",
  name: "Soothing Crystals",
  avatarUrl:
    "https://cdn.faire.com/fastly/0429892ef06e81c7b73442c436f16578802273b842f9d5504404b1a3b8c712bf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e225198a430d434c1ead385e5717acb9fc78ab5cf0dcacc59a304ca136fb1aa4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0429892ef06e81c7b73442c436f16578802273b842f9d5504404b1a3b8c712bf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e225198a430d434c1ead385e5717acb9fc78ab5cf0dcacc59a304ca136fb1aa4.png",
  location: "Claymont, DE, USA",
  minimumOrderDollars: 137,
  rating: 4.8,
  reviewCount: 405,
  isTopShop: true,
  isInsider: true,
  description:
    "Soothing Crystals | Brand Story\n\nAs beings of infinite and boundless possibility, we are gifted with the ability to shape each aspect of our present and future. It is within us to heal the wounds of our past, set our sights on the horizon of the future, and find solace in the stillness of the present. Amid the chaos of daily life, however, connecting with our inner selves and the greater universe can prove challenging. In these moments, the ancient knowledge of crystals reveals their true power.\n\nToday, Soothing Crystals has grown into a trusted online collection of premium-quality crystals, semi-precious stones, jewelry, and healing kits infused with intention and positive energy. Recently, we celebrated welcoming our 50,000th customer, a testament to the trust and loyalty we have fostered within our community over the years. \n\nWe invite you to join us on a cosmic journey of self-discovery with ethically-sourced crystals that empower you to write the next beautiful chapter of your story.\n\nWe are based in USA, but some of our products get manufactured in India, so we ship from both the locations depending on the item ordered.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:19.060Z",
    importedBy: "entity-db-cli",
  },
};
